/* eslint-disable react/no-unused-prop-types */
import { AssetsProvider } from '@obvio/app'

import { ArtistCriticism } from './ArtistCriticism'
import { ArtistDescription } from './ArtistDescription'
import { ArtistFeaturedPhoto } from './ArtistFeaturedPhoto'
import { ArtistInfo } from './ArtistInfo'
import { ArtistName } from './ArtistName'
import { ArtistVideo } from './ArtistVideo'
import { ArtistWorks } from './ArtistWorks'

import type { Data } from '@/pages/artist/[name]'
import type { ReactElement } from 'react'

type ArtistPageProps = Data

export function ArtistPage({
  image,
  description,
  id,
  name,
  products,
  criticism,
  videos,
  exhibitions,
  awards,
  press,
  cv,
}: ArtistPageProps): ReactElement {
  const resolvedImg = Array.isArray(image) ? image[0] : image
  return (
    <AssetsProvider path={`/merchant/${id}`}>
      <ArtistName name={name} />
      {resolvedImg && <ArtistFeaturedPhoto image={resolvedImg} />}
      <ArtistDescription description={description} />
      <ArtistWorks works={products} merchant={{ id, name }} />
      {criticism && <ArtistCriticism criticism={criticism} />}
      {videos && videos.length > 0
        ? videos.map(({ title: vId }: { title: string }) => {
            const parsedId = vId.slice(Math.max(0, vId.lastIndexOf('/') + 1))
            const source = /^\d+$/u.test(parsedId) ? 'vimeo' : 'youtube'

            return <ArtistVideo key={parsedId} id={parsedId} source={source} />
          })
        : null}
      <ArtistInfo
        cv={cv?.[0]}
        press={press}
        awards={awards}
        exhibitions={exhibitions}
      />
    </AssetsProvider>
  )
}
